import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f48d9cf0")

_pushScopeId("data-v-f48d9cf0")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = { class: "ranking__group" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Classement Général:", -1)
const _hoisted_5 = { class: "ranking__container scrollbar--invisible" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RankingTable = _resolveComponent("RankingTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "ranking__general",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleGroupByTeam && _ctx.toggleGroupByTeam(...args)))
        }, [
          _hoisted_4,
          _createVNode("i", {
            class: {
                        'icon-enabled':_ctx.generalRanking,
                        'icon-disabled':!_ctx.generalRanking,
                    }
          }, null, 2)
        ]),
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (d, ix) => {
            return (_openBlock(), _createBlock("div", {
              key: ix,
              class: ["table__wrapper", {'table__wrapper--collapsed': _ctx.isCollapsed(d)}]
            }, [
              _createVNode("div", {
                class: "table__title",
                onClick: ($event: any) => (_ctx.toggleTable(d))
              }, [
                _createTextVNode(_toDisplayString(_ctx.divisionLongDisplayName(d)) + " ", 1),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _hoisted_7
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode("i", {
                        class: {
                                'icon-angle-down': !_ctx.isCollapsed(d),
                                'icon-angle-right': _ctx.isCollapsed(d)
                              }
                      }, null, 2)
                    ]))
              ], 8, ["onClick"]),
              (_ctx.isReady)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode(_component_RankingTable, { category: d }, null, 8, ["category"])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
})